<template>
    <div class="auth-record-box">
        <ul>
            <li>
                <p v-show="isMobile" tkey="有效期">{{i18n.tkey("lang_expiration")}} : </p>
                <span v-show="!isMobile" tkey="有效期">{{i18n.tkey("lang_expiration")}} : </span>
                <el-input
                    v-model="dataObj.addinfo9"
                    type="date"
                    class="date-input"
                    :placeholder="i18n.tkey('lang_start_date')"
                />
                <span> - </span>
                <el-input
                    v-model="dataObj.addinfo10"
                    type="date"
                    class="date-input"
                    :placeholder="i18n.tkey('lang_end_date')"
                />
            </li>

            <li v-show="false">
                <span tkey="3D店鋪">{{i18n.tkey("lang_my_3D_shop")}} : </span>
                <el-checkbox
                    size="large"
                    :checked="dataObj.addremark1.authMap.m2 == -1"
                    @change="clickM2AuthCheckBox"
                />
            </li>

            <li>
                <span tkey="管理員數量上限">{{i18n.tkey("lang_admin_num_limit")}} : </span>
                <el-input
                    v-model="dataObj.addremark1.adminNum"
                    type="number"
                    max="65535"
                    min="0"
                    class="number-input"
                    :placeholder="i18n.tkey('lang_admin_num_limit')"
                />
            </li>

            <li>
                <span tkey="辦展數量上限">{{i18n.tkey("lang_create_hall_num_limit")}} : </span>
                <el-input
                    v-model="dataObj.addremark1.hallNum"
                    type="number"
                    max="65535"
                    min="0"
                    class="number-input"
                    :placeholder="i18n.tkey('lang_create_hall_num_limit')"
                />
            </li>

            <li>
                <span tkey="商場數量上限">{{i18n.tkey("lang_mall_num_limit")}} : </span>
                <el-input
                    v-model="dataObj.addremark1.mallNum"
                    type="number"
                    max="65535"
                    min="0"
                    class="number-input"
                    :placeholder="i18n.tkey('lang_mall_num_limit')"
                />
            </li>

            <li>
                <span tkey="島嶼數量上限">{{i18n.tkey("lang_island_num_limit")}} : </span>
                <el-input
                    v-model="dataObj.addremark1.islandNum"
                    type="number"
                    max="65535"
                    min="0"
                    class="number-input"
                    :placeholder="i18n.tkey('lang_island_num_limit')"
                />
            </li>

            <li>
                <span tkey="子公司數量上限">{{i18n.tkey("lang_sub_company_limit")}} : </span>
                <el-input
                    v-model="dataObj.addremark1.subcompanyNum"
                    type="number"
                    max="65535"
                    min="0"
                    class="number-input"
                    :placeholder="i18n.tkey('lang_sub_company_limit')"
                />
            </li>

            <li>
                <div class="operation-box">
                    <el-button
                        type="primary"
                        v-show="null == tag"
                        @click="clickSave"
                        tkey="保存"
                    >
                        {{i18n.tkey("lang_save")}}
                    </el-button>

                    <el-button
                        type="primary"
                        v-show="'empty' === tag"
                        @click="clickInsert"
                        tkey="保存"
                    >
                        {{i18n.tkey("lang_save")}}
                    </el-button>
                </div>
            </li>
        </ul>
    </div>
</template>

<script setup>

import {inject, ref, onBeforeMount, computed, reactive, watch} from "vue";
import myUtil from "@/util/util";

const props = defineProps(["obj", "tag"])
const emits = defineEmits(["clickSave", "clickInsert"])

const i18n = inject("i18n")
const isMobile = ref(true)

const dataObj = ref({})

watch(() => props.obj, (newValue, oldValue) => {
    if (null != newValue){
        fillDataObj()
    }
});

function clickSave(){
    if (checkValue()){
        emits("clickSave", dataObj.value)
    }
}

function clickInsert(){
    if (checkValue()){
        emits("clickInsert", dataObj.value)
    }
}

function checkValue(){
    if (myUtil.isEmpty(dataObj.value.addinfo9) || myUtil.isEmpty(dataObj.value.addinfo10)){
        myUtil.alertWarning(i18n.tkey("lang_enter_complete"))
        return false
    }

    return true
}

function fillDataObj(){
    const newObj = {}
    const emptyAuthObj = {
        authMap: {
            m2: -1,
        },
        adminNum: 0,
        hallNum: 0,
        mallNum: 0,
        islandNum: 0,
        subcompanyNum: 0,
    }

    if (null != props.obj){
        Object.assign(newObj, props.obj)

        if (null != newObj.addremark1){
            Object.assign(emptyAuthObj, JSON.parse(newObj.addremark1))
        }

        if (null != newObj.addinfo9){
            newObj.addinfo9 = newObj.addinfo9.replaceAll("/", "-")
        }

        if (null != newObj.addinfo10){
            newObj.addinfo10 = newObj.addinfo10.replaceAll("/", "-")
        }

        newObj.addremark1 = emptyAuthObj
    }else{
        newObj.addinfo9 = ""
        newObj.addinfo10 = ""
        newObj.addremark1 = emptyAuthObj
    }

    dataObj.value = newObj
}

function clickM2AuthCheckBox(key){
    if (key == true){
        dataObj.value.addremark1.m2 = -1
    }else{
        dataObj.value.addremark1.m2 = 0
    }
}

onBeforeMount(() => {
    isMobile.value = myUtil.isMobile()

    fillDataObj()
})

</script>

<style scoped>

.auth-record-box {
    width: 100%;
    box-sizing: border-box;
    border: 1px #E4E7ED solid;
    border-radius: 5px;
    padding: 10px;
}

.auth-record-box li {
    margin-bottom: 1em;
}

.operation-box {
    text-align: center;
    margin-top: 10px;
    margin-bottom: 10px;
}

.number-input {
    width: 100px;
}

.date-input {
    width: 130px;
}

</style>